module.exports = __webpack_public_path__ + "assets/img/btn-detail-9e20c43b.png";